import React from "react";
import { Box, BoxProps, Typography, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";

/**
 * @description Component that renders the Menu bar card item for add new Location or Floor.
 */

type CardType = "LOCATION" | "FLOOR";

type P = {
  type: CardType;
  onClick(): void;
};

const CardItemAdd: React.FC<P> = ({ type, onClick }) => {
  const { t } = useTranslation();
  return (
    <StyledParentBox onClick={() => onClick()} data-testid="card-item-add-parent-box">
      <StyledBodyBox data-testid="card-item-add-body-box">
        <Typography variant="h5" sx={{ fontSize: "inherit", color: "inherit", fontWeight: 600 }}>
          {t("Create {{thing}}", { thing: type === "LOCATION" ? t("location") : t("floor") })}
        </Typography>
        <AddIcon sx={{ margin: "10px 0 10px 0", fontSize: 30 }} />
      </StyledBodyBox>
    </StyledParentBox>
  );
};

export default CardItemAdd;

export const StyledParentBox: React.FC<BoxProps> = ({ children, sx, ...rest }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        padding: "21px",
        minWidth: "295px",
        minHeight: "161px",
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        borderRadius: "9px",
        fontSize: 18,
        cursor: "pointer",
        "&:hover": { boxShadow: "0 0 0 2px rgba(255, 255, 255, 1)" },
        "@media (max-device-width: 769px)": { fontSize: 14, minWidth: "210px", minHeight: "145px" },
        "@media (max-device-width: 414px)": { width: "100%" },
        ...sx
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export const StyledBodyBox: React.FC<BoxProps> = ({ children, sx, ...rest }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: "inherit",
        ...sx
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
